import React from 'react';

export const Settings = () => {
    return (
        <div>
            <h1>This is the settings section!</h1>
        </div>
    );
}
